import type { BaseAIAction } from '@ben/columbia/components/assistant/actions/base';
import { CreateBenefitDescription } from '@ben/columbia/components/assistant/actions/description';
import {
  CreateEligibilityRule,
  ExplainEligibilityRule,
  ModifyEligibilityRule,
} from '@ben/columbia/components/assistant/actions/eligibility-rules';
import {
  CreatePricingFormula,
  ExplainPricingFormula,
  ModifyPricingFormula,
} from '@ben/columbia/components/assistant/actions/pricing-formulas';
import _ from 'lodash';

export const getAvailableAIActions = (
  toolName: string,
  currentValue: string,
  onChangeValue: (value: string) => void,
  additionalValue?: unknown
): BaseAIAction[] => {
  switch (toolName) {
    case 'eligibilityRuleQuery': {
      const options: BaseAIAction[] = [];
      if (currentValue === '') {
        // if there is no query, only allow the user to create a new rule
        const createOption = new CreateEligibilityRule();
        createOption.externalSetValue = onChangeValue;
        options.push(createOption);
        return options;
      }

      const currentQuery = currentValue;
      const explainOption = new ExplainEligibilityRule();
      explainOption.externalSetValue = onChangeValue;
      explainOption.args = [currentQuery];
      const modifyOption = new ModifyEligibilityRule();
      modifyOption.externalSetValue = onChangeValue;
      modifyOption.args = [currentQuery];
      options.push(explainOption, modifyOption);

      return options;
    }
    case 'pricingFormula': {
      if (!additionalValue || !_.isNumber(additionalValue)) {
        // as we need the config ID to accurately modify the formula, return no options
        // if there is no config ID
        return [];
      }

      const options: BaseAIAction[] = [];
      if (currentValue === '') {
        // if there is no query, only allow the user to create a new formula
        const createOption = new CreatePricingFormula(additionalValue);
        createOption.externalSetValue = onChangeValue;
        options.push(createOption);
        return options;
      }
      const currentQuery = currentValue;
      const explainOption = new ExplainPricingFormula();
      explainOption.externalSetValue = onChangeValue;
      explainOption.args = [currentQuery];
      const modifyOption = new ModifyPricingFormula(additionalValue);
      modifyOption.externalSetValue = onChangeValue;
      modifyOption.args = [currentQuery];
      options.push(explainOption, modifyOption);

      return options;
    }
    case 'contentEn':
    case 'contentEsXl':
    case 'contentEnUs':
    case 'contentEs':
    case 'contentFr':
    case 'contentDe':
    case 'contentSk':
    case 'contentIt':
    case 'contentMs':
    case 'contentEl':
    case 'contentVi':
    case 'contentZh':
    case 'contentJa':
    case 'contentKo':
    case 'contentPl':
    case 'contentTr':
    case 'contentPt':
    case 'contentHu':
    case 'contentIo': {
      const language = toolName.replace('content', '');
      if (currentValue || language === '') {
        return [];
      }

      const createDescription = new CreateBenefitDescription(language);
      createDescription.externalSetValue = onChangeValue;
      return [createDescription];
    }
    default: {
      break;
    }
  }

  return [];
};
